/**
 * @generated SignedSource<<78e129c4119bd6d975df0477fcb44913>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DurationBasedAgendaSidebarFragment_facility$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"CourseBucketFilterControlFragment_facility" | "DateSelectorControlFragment_facility" | "DurationFilterControlFragment_facility" | "facilityToScheduleOption_facility" | "useFacilityGroupSize_facility" | "useFacilityStartEndTime_facility">;
  readonly " $fragmentType": "DurationBasedAgendaSidebarFragment_facility";
};
export type DurationBasedAgendaSidebarFragment_facility$key = {
  readonly " $data"?: DurationBasedAgendaSidebarFragment_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"DurationBasedAgendaSidebarFragment_facility">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DurationBasedAgendaSidebarFragment_facility",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFacilityStartEndTime_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFacilityGroupSize_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CourseBucketFilterControlFragment_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DurationFilterControlFragment_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DateSelectorControlFragment_facility"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "facilityToScheduleOption_facility",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Department",
          "kind": "LinkedField",
          "name": "department",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Facility",
  "abstractKey": null
};
})();

(node as any).hash = "c57127d183b46e87f368311db563b3cd";

export default node;
